<template>
    <b-navbar-nav>
      <b-nav-item :to="{name: 'teacher.dashboard'}">Überblick</b-nav-item>
      <b-nav-item href="http://www.inkas-berlin.de/hrk_dl_050419.html" target="_blank">Downloads</b-nav-item>
      <b-nav-item-dropdown text="Einstellungen" type="dark">
        <b-dropdown-item :to="{name: 'teacher.settings.user'}">Benutzer</b-dropdown-item>
        <b-dropdown-item :to="{name: 'teacher.settings.school'}">Schule</b-dropdown-item>
        <b-dropdown-item :to="{name: 'teacher.settings.team'}">Kollegium</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
</template>
<script>

export default {
  name: 'NavbarUsers'
}
</script>



// WEBPACK FOOTER //
// src/components/navbar/Users.vue